var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-configs" } },
    [
      _c(
        "v-overlay",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.multipleExporting,
              expression: "multipleExporting",
            },
          ],
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", color: "primary" },
          }),
        ],
        1
      ),
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "mt-1",
                      attrs: { elevation: "0", outlined: "", width: "100%" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text",
                              attrs: { elevation: "0", color: "green" },
                              on: { click: _vm.onPressImportSave },
                            },
                            [
                              _vm._v(" Export snapshots from CSV "),
                              _c(
                                "v-icon",
                                { staticClass: "ml-2", attrs: { size: "20" } },
                                [_vm._v("mdi-database-export-outline")]
                              ),
                            ],
                            1
                          ),
                          _c("input", {
                            ref: "uploader",
                            staticClass: "d-none",
                            attrs: { type: "file", accept: "text/*" },
                            on: { change: _vm.onFileChanged },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "no-transition",
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab",
                        { key: "tab-p-find-user" },
                        [
                          _vm._v("Find User "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-account-search-outline")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab",
                        {
                          key: "tab-p-saves",
                          attrs: { disabled: _vm.isDevelopment() == false },
                        },
                        [
                          _vm._v("Saves "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-content-save-all-outline")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { elevation: "0", width: "100%" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: {
                                color: "red",
                                width: "100%",
                                elevation: "0",
                              },
                            },
                            [
                              _c(
                                "v-tabs-items",
                                {
                                  staticClass: "mt-0",
                                  model: {
                                    value: _vm.tab,
                                    callback: function ($$v) {
                                      _vm.tab = $$v
                                    },
                                    expression: "tab",
                                  },
                                },
                                [
                                  _c(
                                    "v-tab-item",
                                    {
                                      key: "tab-p-find-user",
                                      attrs: {
                                        transition: "fade-transition",
                                        "reverse-transition": "fade-transition",
                                      },
                                    },
                                    [_c("p-find-user")],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    {
                                      key: "tab-p-saves",
                                      attrs: {
                                        transition: "fade-transition",
                                        "reverse-transition": "fade-transition",
                                      },
                                    },
                                    [_c("p-saves")],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }